import Practice from './src/main';

/* istanbul ignore next */
Practice.install = function(Vue) {
  Vue.component(Practice.name, Practice);
};

export default Practice;
